import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Stripev3ResolverService  implements Resolve<any>{

constructor() { }
resolve() {
  return this.loadExternalScript();
}

private loadExternalScript() {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");
    scriptElement.src = "https://js.stripe.com/v3/";
    scriptElement.onload = resolve;
    document.body.appendChild(scriptElement);
  });
}
}
